export default "__VITE_ASSET__CDccTbvq__"